import { SortMenuOption } from 'src/components/subHeader/SubHeaderWithSorting.interface';

export enum RowsPerPageOptions {
  TWENTY = 20,
  FIFTY = 50,
  ONE_HUNDRED = 100,
  ALL = 'All',
}

export enum ControlType {
  SORT = 'sort',
  ITEMS_PER_PAGE = 'itemsPerPage',
  CLEAR_SECTION = 'clearSection',
}

export interface TableControlsHeaderProps {
  page: number;
  rowsPerPage: number;
  totalCount: number;
  selectedSortOption?: SortMenuOption;
  selectedItems?: [];
  sortItems?: {
    label: string;
    isSelected: boolean;
    onClick: () => void;
  }[];
  onSortChange?: (selectedOption: SortMenuOption) => void;
  rowsPerPageItems?: {
    label: string;
    isSelected: boolean;
    onClick: () => void;
  }[];
  onRowsPerPageChange?: (rowsPerPage: number) => void;
  visibleControls?: ControlType[];
  selectedCount?: number;
  onClearSelection?: () => void;
}
